<ws-modal-wrapper [headerLabel]="'Parcel Collector Tax Rate Setup' + (title ? ' - ' + title : '')"
                  [hideFooter]="true"
                  [excludeModalStyling]="true"
                  [loading]="loadingAll"
                  (cancel)="closeModal()">
    <div class="tax-rate-setup">
        @if (model && !loadingAll) {
            <div class="row content-container">
                @if (readOnly) {
                    <div class="top-actions">
                        <span style="font-weight:bold;">Tax Rate Area:</span>
                        <span>{{ model.name || '(none)' }}</span>
                    </div>
                }
                @if (!readOnly) {
                    <div class="top-actions">
                        <label>Tax Rate Area:</label>
                        <input
                            #taxRateAreaInput
                            name="taxRateArea"
                            type="text"
                            placeholder="Tax Rate Area..."
                            class="form-control"
                            autocomplete="off"
                            [ngModel]="model.name"
                            (blur)="onTaxRateAreaTextChange()"
                            [disabled]="loading"
                            [wsTypeahead]="availableTaxRateAreas"
                            typeaheadOptionField="name"
                            [typeaheadScrollable]="true"
                            [typeaheadMinLength]="0"
                            [typeaheadOptionsLimit]="99999"
                            (typeaheadOnSelect)="onTaxRateAreaIdChange($event)"/>
                        <div class="clear-tax-rate-container">
                            @if (model.taxRateAreaId) {
                                <button
                                    [disabled]="loading"
                                    type="button"
                                    class="edit-control btn-sm ace-btn has-icon btn-primary btn-danger"
                                    (click)="clearSelectedTaxRateAreaId()"
                                >
                                    <i class="fa fa-close"></i>
                                </button>
                            }
                        </div>
                        <!-- <button type="button" class="ace-btn info-button btn-sm search" [disabled]="loading">Search</button> -->
                    </div>
                }
                <hr/>
                @if (!loadingAll && !isDocumentProcessing) {
                    <label class="year-label">
                        Show Rates for Tax Year:
                        <select
                            [disabled]="loading"
                            [ngModel]="displayYear"
                            (ngModelChange)="onDisplayYearChange($event)"
                            class="form-select form-select-sm"
                        >
                            @for (year of availableYears; track year) {
                                <option>{{ year }}</option>
                            }
                        </select>
                    </label>
                }
                @if (loading) {
                    <div class="text-center" style="margin: 50px;">
                        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                    </div>
                }
                @if (!loading) {
                    <div class="table-container">
                        <table class="tax-rate-setup">
                            <tr>
                                <th>Code</th>
                                <th>Tax Authority</th>
                                <th>Category</th>
                                <th>Assessment Source</th>
                                <th>Exemptions Honored</th>
                                <th class="right-align" style="width:4em">Rate</th>
                                <th></th>
                            </tr>
                            @for (group of currentTaxAuthorityGroups; track group; let i = $index) {
                                @if (groupByCategory && i !== 0) {
                                    <tr class="grouping-spacer">
                                        <td colspan="5"></td>
                                    </tr>
                                }
                                @for (taxAuthority of group.taxAuthorities; track taxAuthority) {
                                    <tr>
                                        <td>{{ taxAuthority.code }}</td>
                                        <td>{{ taxAuthority.name }}</td>
                                        <td>{{ taxAuthorityCategoryName(taxAuthority.taxAuthorityCategoryId) }}</td>
                                        <td>{{ taxableAssessmentTypeName(taxAuthority.displayTaxableAssessmentTypeId) }}</td>
                                        <td>{{ taxAuthorityExemptionTypeName(taxAuthority.taxAuthorityExemptionTypeId) }}
                                            <span helpTooltip
                                                  position="top"
                                                  [hasIcon]="true"
                                                  [style.visibility]="showToolTip(taxAuthority) ? 'visible' : 'hidden'"
                                                  [contentComponent]="getAdjustmentContentComponent(taxAuthority)">
                                            </span>
                                        </td>
                                        <td [class]="'right-align ' + rateClass(taxAuthority)"
                                            [tooltip]="taTooltip(taxAuthority)"
                                            container="body">
                                            {{ taxAuthority.rate * 100 | number:"1.6-6" }}
                                        </td>
                                        <td>
                                            @if (!model.taxRateAreaId && !readOnly) {
                                                <button
                                                    [disabled]="loading"
                                                    type="button"
                                                    class="edit-control btn-sm ace-btn has-icon btn-primary btn-danger remove-authority"
                                                    (click)="removeTaxAuthority(taxAuthority)"
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                }
                            }
                            <tr class="no-hover">
                                <td colspan="4">
                                    @if (model && !model.taxRateAreaId && filteredAvailableTaxAuthorities.length > 0 && !readOnly) {
                                        <select
                                            [ngModel]="newTaxAuthorityId"
                                            (ngModelChange)="onNewTaxAuthorityChange($event)"
                                            [disabled]="loading"
                                            class="form-select form-select-sm new-tax-auth"
                                        >
                                            <option value="">Add new tax authority</option>
                                            @for (
                                                availableTaxAuthority of filteredAvailableTaxAuthorities; track availableTaxAuthority) {
                                                <option [value]="availableTaxAuthority.taxAuthorityId">
                                                    {{ availableTaxAuthority.name }}
                                                </option>
                                            }
                                        </select>
                                    }
                                    @if (model && !model.taxRateAreaId && filteredAvailableTaxAuthorities.length <= 0) {
                                        <span>
                                            (no more available tax authorities to add)
                                        </span>
                                    }
                                </td>
                                @if (model && model.taxAuthorities && model.taxAuthorities.length > 0) {
                                    <td class="total-label">Total:</td>
                                    <td [class]="totalEstimated ? 'total-rate estimated' : 'total-rate'">{{ totalRate * 100 | number:"1.6-6" }}</td>
                                    <td></td>
                                }
                                @if (!(model && model.taxAuthorities && model.taxAuthorities.length > 0)) {
                                    <td colspan="3"></td>
                                }
                            </tr>
                        </table>
                    </div>
                }
                <hr/>
            </div>
        }
    </div>
    <div class="modal-footer tax-rate-setup">
        @if (!loadingAll) {
            <div class="group-by-category">
                <label>
                    <input type="checkbox"
                           [ngModel]="groupByCategory"
                           (ngModelChange)="onGroupByCategoryChanged($event)"/>
                    Group by Category
                </label>
            </div>
        }
        @if (!readOnly) {
            <div class="action-buttons">
                @if (!isDocumentProcessing) {
                    <button class="ace-btn btn-primary" [disabled]="loading || loadingAll" (click)="save()">Save
                    </button>
                }
                @if (isDocumentProcessing) {
                    <button class="ace-btn btn-primary" [disabled]="loading || loadingAll" (click)="save()">OK</button>
                }
                <button class="ace-btn btn-secondary" (click)="closeModal()">Cancel</button>
            </div>
        }
        @if (readOnly) {
            <div class="action-buttons">
                <button class="ace-btn btn-secondary" (click)="closeModal()">Done</button>
            </div>
        }
    </div>
</ws-modal-wrapper>
